import { render, staticRenderFns } from "./UnisaludLegal.vue?vue&type=template&id=ed8605d4&scoped=true"
import script from "./UnisaludLegal.vue?vue&type=script&lang=js"
export * from "./UnisaludLegal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed8605d4",
  null
  
)

export default component.exports